<h4 matDialogTitle>Adding {{ hireItem.item.code }}</h4>
<form [formGroup]="formGroup">
  <mat-dialog-content>
    <div class="flex flex-col justify-start items-stretch gap-y-4">
      <p class="mb-5">
        To help predict availability, please specify an estimated return date
        and time.
      </p>

      <div
        class="flex md:flex-row md:justify-center md:items-center md:gap-x-4 flex-col justify-start items-stretch gap-y-4">
        <button mat-flat-button [testId]="testIds.ONE_DAY" (click)="quickDate(1, 'day')">
          1 Day
        </button>
        <button mat-flat-button [testId]="testIds.TWO_DAYS" (click)="quickDate(2, 'day')">
          2 Day
        </button>
        <button mat-flat-button [testId]="testIds.THREE_DAYS" (click)="quickDate(3, 'day')">
          3 Day
        </button>
        <button mat-flat-button [testId]="testIds.ONE_WEEK" (click)="quickDate(1, 'week')">
          1 Week
        </button>
        <button mat-flat-button [testId]="testIds.TWO_WEEKS" (click)="quickDate(2, 'week')">
          2 Weeks
        </button>
      </div>
      <div class="flex flex-row justify-start items-start gap-x-4">
        <mat-form-field class="basis-full">
          <input type="text" [matDatepicker]="picker" formControlName="offHireDate" autocomplete="off"
            id="estimated-return-date" autofocus required placeholder="Est. Return Date" matInput />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="basis-full">
          <mat-label>Off hire time</mat-label>
          <input matInput name="offHireTime" formControlName="offHireTime"
            (blur)="updateTimeEnteredManually('offHireTime', pickerOff)" placeholder="Off hire time" />
          @if (formGroup.get('offHireTime').hasError('invalidTime')) {
          <mat-error>Invalid time value, please enter in the format: HH:mm (24
            hour)</mat-error>
          }
          <mat-icon matSuffix (click)="pickerOff.open()">access_time</mat-icon>
        </mat-form-field>
        <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
          (timeSet)="updateTime($event, 'offHireTime')" #pickerOff></ngx-mat-timepicker>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="dialogRef.close()" type="button">
      Cancel
    </button>
    <button mat-raised-button [disabled]="!formGroup.valid" color="primary" (click)="submit()" id="add-item"
      type="submit">
      Save
    </button>
  </mat-dialog-actions>
</form>